// extracted by mini-css-extract-plugin
export var linkText = "_on-0";